<!-- <mat-drawer-container class="example-container" [hasBackdrop]="hasBackdrop.value">
    <mat-drawer #drawer [mode]="mode.value" [position]="'end'">I'm a drawer</mat-drawer>
    <mat-drawer-content>
      <mat-form-field>
        <mat-label>Sidenav mode</mat-label>
        <mat-select #mode value="side">
          <mat-option value="side">Side</mat-option>
          <mat-option value="over">Over</mat-option>
          <mat-option value="push">Push</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Has backdrop</mat-label>
        <mat-select #hasBackdrop>
          <mat-option>Unset</mat-option>
          <mat-option [value]="true">True</mat-option>
          <mat-option [value]="false">False</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button (click)="drawer.toggle()">Toggle drawer</button>
    </mat-drawer-content>
  </mat-drawer-container> -->

  <mat-drawer-container [hasBackdrop]="false">
    <mat-drawer #neocortexDrawer [mode]="'side'" [position]="'start'" [opened]="true">
        <div class="neocortex-window">
            <div class="res-container">
                <div class="res-title">
                    <span class="res-title">New Neocortex</span>
                    <span class="res-icon" (click)="showPrompt()"><mat-icon style="cursor: pointer;">
                            edit_square
                        </mat-icon></span>
                </div>
            </div>
            <cdk-virtual-scroll-viewport itemSize="20" class="Neocortex-list-virtual-scroll">
                <div *cdkVirtualFor="let neocortex of neocortexList" class="res-container">
                    <div class="res-title">
                        <span [ngClass]="conversation_id == neocortex.conversation_id ? 'selectedChat':''"
                            *ngIf="neocortex.conversation_name != '' && neocortex.conversation_name.length > 26"
                            (click)="getInteractionsNeocortex(neocortex.conversation_id,neocortex.conversation_name)"
                            class="res-title"
                            matTooltip="{{ neocortex.conversation_name }}">{{neocortex.conversation_name.slice(0,
                            26)}}...</span>
                        <span [ngClass]="conversation_id == neocortex.conversation_id ? 'selectedChat':''"
                            *ngIf="neocortex.conversation_name != '' && neocortex.conversation_name.length <= 26"
                            (click)="getInteractionsNeocortex(neocortex.conversation_id,neocortex.conversation_name)"
                            class="res-title">{{neocortex.conversation_name}}</span>
                        <span class="res-icon"><mat-icon [matMenuTriggerFor]="conversationMenu"
                                style="cursor: pointer;">
                                more_horiz
                            </mat-icon></span>
                        <mat-menu #conversationMenu="matMenu" xPosition="after" [overlapTrigger]="false"
                            [hasBackdrop]="true">
                            <mat-list>
                                <mat-list-item (click)="confirmDelectAlert(neocortex)" class="settings-menu">
                                    <div matListItemTitle class="mat-menu-text">Delete</div>
                                </mat-list-item>
                                <mat-list-item (click)="updateConversationPompt(neocortex)" class="settings-menu">
                                    <div matListItemTitle class="mat-menu-text">Edit</div>
                                </mat-list-item>
                            </mat-list>
                        </mat-menu>
                    </div>
                </div>
            </cdk-virtual-scroll-viewport>

        </div>
    </mat-drawer>
    <mat-drawer-content>
        <div class="content-grid">
            <mat-card>
                <mat-card-content class="mc-content">
                    <div class="main-grid">
                        <div class="chat-window">
                            <div style="height: 55px;">
                                <!-- <div class="header-logo">
                                    <img src="../../assets/images/Goldfinch_landing_h_Image.jpg" style="width: 320px;">
                                </div> -->
                                <mat-progress-bar *ngIf="loadingMoreInteractions"
                                    mode="indeterminate"></mat-progress-bar>
                            </div>
                            <!-- {{scrollChatWindow.scrollTop}}
                            {{scrollChatWindow.scrollHeight}} -->
                            <div class="message-wrap" id="div" #scrollChatWindow (scroll)="onScroll()">
                                <div *ngFor="let msg of messages;let i=index" class="message" [class.left]="msg.author == 'bot' "
                                    [class.right]="msg.author == 'user'">
                                    <img *ngIf="msg.author === 'bot'" class="user-img-bot"
                                        src="../../assets/images/Goldfinch_new.png">
                                    <img width="10" height="10" [routerLink]="['/baseapp/profile']"
                                        *ngIf="msg.author === 'user'" class="user-img" [src]="profileImagePath">
                                    <div class="msg-detail">
                                        <!-- <div class="msg-info">
                                                <p>{{msg.timeStamp}}</p>
                                            </div> -->
                                        <!-- <div *ngIf="msg.author === 'bot'" class="msg-content"> -->
                                        <div *ngIf="msg.content == ''" class="msg-content"
                                            style="background-color: #fff !important;">
                                            <span class="triangle" style="background-color: #fff !important;"></span>
                                            <mat-spinner class="orange-spinner"
                                                *ngIf="msg.author === 'bot' && msg.content == ''" class="btn-spinner"
                                                diameter="30"></mat-spinner>
                                        </div>
                                        <!-- <div class="msg-content" *ngIf="msg.content != '' && msg.author === 'bot'">
                                                    <span class="triangle"></span>
                                                    <markdown *ngIf="msg.content != '' && msg.author === 'bot'" class="variable-binding" [data]="msg.content"></markdown>
                                                </div>
                                                <div class="msg-content" *ngIf="msg.content != '' && msg.author === 'user'">
                                                    <span class="triangle"></span>
                                                    <p *ngIf="msg.content != '' && msg.author == 'user'">{{msg.content}}</p>
                                                </div> -->
                                        <!-- <div class="msg-info" *ngIf="msg.author == 'bot'">
                                                    <p style="display: block; text-align: right;">{{msg.timeStamp}}</p>
                                                </div> -->
                                        <div class="msg-content-frame"
                                            *ngIf="msg.content != '' && msg.author === 'bot'">
                                            <div class="msg-content" *ngIf="msg.content != '' && msg.author === 'bot'">
                                                <span class="triangle"></span>
                                                <!-- <markdown *ngIf="msg.content != '' && msg.author === 'bot'" class="variable-binding" [data]="msg.content"></markdown> -->
                                                <div clipboard [clipboardButtonComponent]="clipboardButton" markdown
                                                    [data]="msg.content"
                                                    id="bot_message_{{i}}"
                                                    *ngIf="msg.content != '' && msg.author === 'bot'"
                                                    class="variable-binding"
                                                    (click)="openLink(i)"></div>
                                            </div>
                                            <div class="msg-info" *ngIf="msg.author == 'bot'">
                                                <div class="msg-actions">
                                                    <mat-icon [matTooltip]="copyStr" (click)="copyResponse(i)">
                                                        content_paste
                                                    </mat-icon>
                                                    <mat-icon [matTooltip]="'Regenerate'" (click)="regenerateResponse(i)" *ngIf="!sending">
                                                        autorenew
                                                    </mat-icon>
                                                    <mat-icon matTooltip="Bad response" 
                                                    (click)="dislikeMessage(msg.messageId, i)">
                                                    {{ msg.is_dislike == 1 ? 'thumb_down' : 'thumb_down_off_alt' }}
                                                </mat-icon>
                                                </div>
                                                <p>{{msg.timeStamp}}</p>
                                            </div>
                                        </div>

                                        <div class="msg-content-frame"
                                            *ngIf="msg.content != '' && msg.author === 'user'">
                                            <div class="msg-content" *ngIf="msg.content != '' && msg.author === 'user'">
                                                <span class="triangle"></span>
                                                <pre *ngIf="msg.content != '' && msg.author == 'user'"
                                                    [innerHTML]="msg.content"></pre>
                                            </div>
                                            <div class="msg-info" *ngIf="msg.author == 'user'">
                                                <p>{{msg.timeStamp}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- </div> -->
                                    <!-- <div class="msg-info">
                                            <p *ngIf="msg.author == 'user'" style="text-align: right;padding-right: 60px;font-size: 0.8em;color: #888;">{{msg.timeStamp}}</p>
                                            <p *ngIf="msg.author == 'bot'" style="padding-left: 60px;font-size: 0.8em;color: #888;">{{msg.timeStamp}}</p>
                                        </div> -->
                                </div>

                                <div *ngIf="showScrollButton && messages.length>0" class="scroll-button-container"
                                    (click)="smoothScrollToBottom()">
                                    <button mat-mini-fab class="scroll-button" aria-label="Scroll to Bottom">
                                        <mat-icon style="font-size: 16px;">arrow_downward</mat-icon>
                                    </button>
                                </div>

                            </div>
                            <!-- <div class="input-wrap"> -->
                            <!-- <div class="chat-container" style="padding-left: 60px;"> -->
                            <!-- <textarea class="search-box" name="Text1" cols="40" rows="20" #questionInputBox
                                        type="text" [(ngModel)]="editorMsg"
                                        placeholder="Ask any question from your Data Source"
                                        (keydown.enter)="sendMessage()" (keyup)="validateDataSource($event)"
                                        [readonly]="isReadonly"></textarea>
                                    <span>
                                        <img class="search-icon" src="../../../assets/icon/up-arrow.png"
                                            [ngClass]="{'disable':editorMsg== '' || data_source_index_name == ''}"
                                            matSuffix (click)="sendMessage()" style="width: 35px;margin-right: 10px;"
                                            *ngIf="!isReadonly" />
                                    </span> -->
                            <div class="textarea-container">
                                <textarea class="search-box" name="Text1" cols="40" rows="20" #questionInputBox
                                    type="text" [(ngModel)]="editorMsg" (keyup)="validateDataSource($event)"
                                    placeholder="Ask any question from your Data Source" (keydown.enter)="sendMessage($event)"
                                    [readonly]="isReadonly"></textarea>
                                <button *ngIf="isAccess"  mat-icon-button (click)="startListening()" class="search-icon mic">
                                    <mat-icon style="font-size: 28px;" >{{ isRecording ? 'mic' : 'mic_off' }}</mat-icon>
                                  </button>
                                <img class="search-icon" src="../../../assets/icon/up-arrow.png"
                                    [ngClass]="{'disable':editorMsg== '' || data_source_index_name == ''}" matSuffix
                                    (click)="sendMessage()" style="width: 35px;margin-right: 10px;"
                                    *ngIf="sending? false:!isReadonly" />
                                        <img class="search-icon" src="../../assets/icon/sq.png" *ngIf="sending" matSuffix (click)="stopResponse()"  style="  width: 32px; margin-right: 10px;
                                        border-radius: 9px;
                                        margin-top: 2px;"  />
                               
                         
                                <!-- </div> -->
                                <p style="text-align: center;width:80%;margin:0 auto;margin-top: 0px;font-size: 10px;">
                                    Goldfinch is learning fast. We recommend confirming important information before
                                    making any critical decisions.</p>

                                <!-- <mat-form-field appearance="outline" class="chat-container"
                                    style="padding-left: 60px;padding-right: 60px;">
                                    <textarea #questionInputBox type="text" matInput cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"
                                        [(ngModel)]="editorMsg" placeholder="Ask any question from your Data Source"
                                        (keydown.enter)="sendMessage()" (keyup)="validateDataSource($event)"
                                        [readonly]="isReadonly">
                                    </textarea>
                                    <mat-icon [ngClass]="{'disable':editorMsg== '' || data_source_index_name == ''}"
                                        matSuffix (click)="sendMessage()">send</mat-icon>
                                </mat-form-field> -->
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </mat-drawer-content>
    <mat-drawer #DataSourcedrawer [mode]="'side'" [position]="'end'" [opened]="true">
        <div class="header-model">
            <div style="padding:15px">
                <!-- <mat-chip class="header-chip" [matMenuTriggerFor]="dataSourceMenu" style="padding: 0 !important;">
                    <span *ngIf="data_source_index_name == '' || data_source_index_name == undefined">Data Source</span>
                    <span
                        *ngIf="data_source_index_name != '' && data_source_index_name != undefined && data_source_index_name.length <= 25">
                        {{ data_source_index_name }}
                    </span>
                    <span
                        *ngIf="data_source_index_name != '' && data_source_index_name != undefined && data_source_index_name.length > 25"
                        [matTooltip]="data_source_index_name">
                        {{ data_source_index_name.slice(0, 25) }}...
                    </span>
                    <button [matMenuTriggerFor]="dataSourceMenu" matChipRemove>
                        <mat-icon>expand_more</mat-icon>
                    </button>
                </mat-chip> -->
                <form class="example-form">
                    <mat-form-field class="example-full-width" appearance="outline">
                        <mat-icon style="padding:0;padding-bottom: 1px;padding-left: 3px;" matPrefix>search</mat-icon>
                        <input #stateInput id="stateInput" (keyup)="0" matInput placeholder="Data source" aria-label="DataSource" [matAutocomplete]="auto"
                            [formControl]="stateCtrl" id="stateInput">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option class="stateInput"
                                (onSelectionChange)="stateInput.value !=undefined && onChangeIndexMgmtName(state,data_source_previou_index_name)"
                                *ngFor="let state of indexMgntListNew$ | async" [value]="state.index_name">
                                <span
                                *ngIf="state.index_name != '' && state.index_name != undefined && state.index_name.length <= 25">
                                {{ state.index_name }}
                            </span>
                            <span
                                *ngIf="state.index_name != '' && state.index_name != undefined && state.index_name.length > 25"
                                [matTooltip]="state.index_name">
                                {{ state.index_name.slice(0, 25) }}...
                            </span>

                            </mat-option>
                        </mat-autocomplete>
                      
                       
                        <button type="button" mat-icon-button [disableRipple]="true" matSuffix aria-label="Search" *ngIf="stateCtrl.value" (click)="clearDataSource()">
                            <mat-icon matPrefix>clear</mat-icon>
                        </button>
                    </mat-form-field>
                </form>
                <mat-chip class="header-chip" [matMenuTriggerFor]="AIModalMenu" style="padding: 0 !important;">
                    <span *ngIf="ai_modal_name == '' || ai_modal_name == undefined">AI Model</span>
                    <span *ngIf="ai_modal_name != '' && ai_modal_name != undefined && ai_modal_name.length <= 25">
                        {{ ai_modal_name }}
                    </span>
                    <span *ngIf="ai_modal_name != '' && ai_modal_name != undefined && ai_modal_name.length > 25"
                        [matTooltip]="ai_modal_name">
                        {{ ai_modal_name.slice(0, 25) }}...
                    </span>
                    <button [matMenuTriggerFor]="AIModalMenu" matChipRemove>
                        <mat-icon>expand_more</mat-icon>
                    </button>
                </mat-chip>
                
            </div>
            <mat-menu #dataSourceMenu="matMenu" xPosition="after" [overlapTrigger]="false" [hasBackdrop]="true">
                <mat-list style="padding: 0 !important;">
                    <mat-list-item class="settings-menu" *ngIf="indexMgntList.length == 0">
                        <div class="res-container" matListItemTitle>
                            <div class="res-title">
                                <span class="res-title">No record found</span>
                            </div>
                        </div>
                    </mat-list-item>
                    <ng-container *ngIf="indexMgntList.length > 0">
                        <mat-list-item class="settings-menu" *ngFor="let obj of indexMgntList"
                            style="height: 22px !important"
                            (click)="onChangeIndexMgmtName(obj,data_source_previou_index_name)">
                            <div class="res-container" matListItemTitle>
                                <div class="res-title"
                                    style="overflow: hidden; text-overflow: ellipsis;cursor: pointer;">
                                    <span (click)="onChangeIndexMgmtName(obj,data_source_previou_index_name)"
                                        *ngIf="obj.index_name == data_source_index_name" class="res-icon">
                                        <!-- <mat-icon style="cursor: pointer;padding-top: 6px;">
                                        check
                                    </mat-icon> -->
                                    </span>

                                    <span class="res-title"
                                        [ngStyle]="{'font-size': '12px', 'font-weight': obj.index_name == data_source_index_name ? 'bold' : 'normal'}">
                                        {{ obj.index_name }}
                                    </span>
                                </div>
                            </div>
                        </mat-list-item>
                    </ng-container>
                </mat-list>
                
            </mat-menu>
            <mat-menu #AIModalMenu="matMenu" xPosition="after" [overlapTrigger]="false" [hasBackdrop]="true">
                <mat-list style="padding: 0 !important;">
                    <mat-list-item class="settings-menu" *ngIf="aiModelList.length == 0">
                        <div class="res-container" matListItemTitle>
                            <div class="res-title">
                                <span class="res-title">No record found</span>
                            </div>
                        </div>
                    </mat-list-item>
                    <ng-container *ngIf="aiModelList.length > 0">
                        <mat-list-item class="settings-menu" *ngFor="let obj of aiModelList"
                            style="height: 22px !important" (click)="onChangeAIModal(obj,ai_modal_previous_name)">
                            <div class="res-container" matListItemTitle>
                                <div class="res-title"
                                    style="overflow: hidden; text-overflow: ellipsis;cursor: pointer;">
                                    <span (click)="onChangeAIModal(obj,ai_modal_previous_name)"
                                        *ngIf="obj.ai_model_name == ai_modal_name" class="res-icon">
                                        <!-- <mat-icon style="cursor: pointer;padding-top: 6px;">
                                        check
                                    </mat-icon> -->
                                    </span>
                                    <span class="res-title"
                                        [ngStyle]="{'font-size': '12px', 'font-weight': obj.ai_model_name == ai_modal_name ? 'bold' : 'normal'}">
                                        {{ obj.ai_model_name }}
                                    </span>
                                </div>
                            </div>
                        </mat-list-item>
                    </ng-container>
                </mat-list>
            </mat-menu>
        </div>
    </mat-drawer>
</mat-drawer-container>